import { IMenSis } from '../types/MenSis';

// A API (/menu) sempre manda `filhos`, vazio nas folhas: testar só `item.filhos` dá true
// para um array vazio e impedia a navegação nos itens de 2º nível.
export function temFilhos(item?: IMenSis): boolean {
  return !!item?.filhos && item.filhos.length > 0;
}

export function iconeMenu(item?: IMenSis, padrao = 'FaAlignJustify'): string {
  return item?.nomico || padrao;
}
